// src/data/eventData.js
const events = [
  {
    id: 1,
    title: 'Stegall Product Market',
    date: 'Saturday, October 24th',
    time: '9:00AM - 2:00PM',
    address: '6411 Old Monroe Rd, Indian Trail, NC 28079, United States'
  },
  {
    id: 2,
    title: 'K|LA Boutique Pop-Up',
    date: 'Sunday, October 25th',
    time: '12:00AM - 2:00PM',
    address: 'K|LA Boutique, 4123 Park Rd, Charlotte, NC 28209, United States'
  },
  {
    id: 3,
    title: 'K|LA Boutique Pop-Up',
    date: 'Saturday, November 14th',
    time: '11:00AM - 2:00PM',
    address: 'K|LA Boutique, 4123 Park Rd, Charlotte, NC 28209, United States'
  },
  {
    id: 4,
    title: 'Anson County Farmers Market Thanksgiving Event',
    date: 'Saturday, November 21st',
    time: '1:00PM - 5:00PM',
    address: '1736 US-52, Wadesboro, NC 28170, United States'
  },
  {
    id: 5,
    title: 'Union County Farmers Market',
    date: 'Saturday, December 12th',
    time: '8:00AM - 12:00PM',
    address: '805 Skyway Dr, Monroe, NC 28110, United States'
  },

];

export default events;
